import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import { Form, FormGroup, Grid, Row, Col, Button, FormControl, Table, Panel, Breadcrumb, Modal } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import {connect} from "react-redux";
import DatetimeRangePicker from "../../DatetimeRangePicker";
import {ReactHighcharts, ReactHighstock} from "../../../lib/react-highcharts";
import $ from "jquery";
import moment from "moment";
import locale from "locale";
import "moment/locale/ru";
import "./style.less";
import Loading from "components/Loading";
import {getClientNickname, getHumanDuration} from "tools";
import ClientTable from "./ClientTable";
import StatisticPieTable from "./StatisticPieTable";
import {
    eventStatisticActivityTopGet,
    eventStatisticBannersGet,
    eventStatisticBrowsersGet,
    eventStatisticCitiesGet,
    eventStatisticClientsGet,
    eventStatisticCountriesGet,
    eventStatisticDevicesGet,
    eventStatisticHostsGet,
    eventStatisticMessagesGet,
    eventStatisticNotificationsGet,
    eventStatisticOnlineGet,
    eventStatisticPaymentsGet,
    eventStatisticPollsGet, eventStatisticRegistrationConversion,
    eventStatisticStreamsGet,
    eventStatisticTimeLineGet,
    eventStatisticViewTimeClientsGet,
    eventStatisticViewTimeGet,
    eventStatisticPollsMember
} from "api";
import { Event } from "../../Comet";

const UnknownLabel = 'Не определено';
const DatetimeRangePickerLocale = {
	format: 'YYYY-MM-DD HH:mm:ss',
	applyLabel: 'Применить',
	cancelLabel: 'Отмена',
	fromLabel: 'С',
	toLabel: 'По',
	customRangeLabel: 'Custom',
	weekLabel: 'Н',
	daysOfWeek: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
	monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
	firstDay: 1
};

ReactHighcharts.Highcharts.setOptions({
	global: {
		useUTC: false
	}
});
ReactHighstock.Highcharts.setOptions({
	global: {
		useUTC: false
	}
});

const WatchDurationClientListModal = ({event, onHide, timeStart, timeStop, minDuration, maxDuration}) => {
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(false);

    const fields = {
        surname: 'Фамилия',
        name: 'Имя',
        patronymic: 'Отчество',
        link: 'Профиль'
    };

    useEffect(() => {
        setClients([]);
        if (!minDuration && !maxDuration) {
            return;
        }

        const params = {
            timeStart,
            timeStop,
        };

        if (minDuration > 0) {
            params.minDuration = minDuration;
        }
        if (maxDuration > 0) {
            params.maxDuration = maxDuration;
        }

        setLoading(true);
        eventStatisticViewTimeClientsGet(event.eventPassword, params)
            .then(clients => setClients(clients))
            .catch(() => {})
            .then(() => setLoading(false))
        ;
    }, [minDuration, maxDuration]);

    event.registrationFields.forEach(fieldToEvent => {
        const field = fieldToEvent.field;
        if(!fields[field.name]) {
            fields[field.name] = field.label_ru;
        }
    });

    const getClientInfo = (client, key) => {
        const socialTypes = {
            guest: 'Гость',
            email: 'COMDI',
            vk: 'Вконтакте',
            facebook: "Facebook",
            twitter: "Twitter",
            mailru: "Mail.ru",
            linkedin: "Linked.in",
            google: "Google",
            ok: "Одноклассники",
            yandex: "Яндекс",
            kaspersky: "Касперский",
        };

        switch(key) {
            case 'link': return client.info.link ? <a href={client.info.link} target="_blank">{socialTypes[client.type] || 'Перейти'}</a> : null;
            default: return client[key] || (client.info ? client.info[key] : null) || '';
        }
    };

    const ClientRow = ({client}) => {
        if (!client.id) {
            return (
                <tr>
                    <td>{client.deviceId}</td>
                    <td colSpan={2 + Object.keys(fields).length}>
                        Не авторизован
                    </td>
                </tr>
            );
        }

        return (
            <tr>
                <td>{client.deviceId}</td>
                <td><Link to={`/event/${event.eventPassword}/client/${client.id}`}>{client.id}</Link></td>
                <td>{client.email || ''}</td>
                {Object.keys(fields).map(key => <td key={key}>{getClientInfo(client, key)}</td>)}
            </tr>
        );
    };

    const Content = ({clients, loading}) => {
        if (loading) {
            return (
                <Loading></Loading>
            );
        }

        return (
            <Table>
                <thead>
                <tr>
                    <th>ID Устройства</th>
                    <th>ID Зрителя</th>
                    <th>eMail</th>
                    {Object.keys(fields).map(key => <th key={key}>{fields[key]}</th>)}
                </tr>
                </thead>
                <tbody>
                {clients.map(client => <ClientRow client={client} key={client.id} />)}
                </tbody>
            </Table>
        );
    };

    return (
        <Modal show={minDuration > 0 || maxDuration > 0} onHide={onHide} bsSize="large">
            <Modal.Header closeButton>
                <Modal.Title>Зрители</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Content clients={clients} loading={loading} />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onHide}>Закрыть</Button>
            </Modal.Footer>
        </Modal>
    );
};

const StatisticTimeLine = (
    {
        event,
        timeStop,
        timeLine,
        usersConnect,
        usersOnline,
        usersUnique,
        clients,
        usersOnlineMax,
        avgViewTime,
        commentsCount,
        questionsCount,
        registrationConversion,
        usersWatchedLive,
        polsMembersUnique,
        quizzesMembersUnique,
    }) => {
	if(!timeLine.length) return null;

    const dataByTime = {};
    let lastTime = 0
    timeLine.forEach(item => {
        dataByTime[item.time] = item;
        lastTime = Math.max(lastTime, item.time);
    });

    const data = [];
    let lastOnline = 0;
    for (let time = timeLine[0].time; time <= lastTime; time+=60) {
        let item = dataByTime[time] || {
            time: time,
            online: lastOnline,
            connect: 0,
            disconnect: 0,
        };
        data.push(item);
        lastOnline = item.online;
    }
    if (lastTime < timeStop) {
        data.push({
            time: timeStop,
            online: data[data.length - 1].online,
            connect: 0,
            disconnect: 0,
        });
    }

	const chartConfig = {
        accessibility: {
            enabled: false,
        },
		credits: {enabled: false},
		chart: {zoomType: 'x'},
		colors: ['#06E213', '#00A1F0', '#E06136'],
		title: {
			text: null
		},
		rangeSelector: {
//			enabled: false
			inputEnabled: false,
			inputBoxWidth: 120,
			buttons: [
				{type: 'minute', count: 60, text: 'Час'},
				{type: 'all', text: 'Весь'}
			],
			selected: 1
		},
		navigator: {
			maskFill: 'rgba(0, 0, 0, .1)',
			outlineColor: '#e3e3e3'
		},
		series: [{
			type: 'spline',
			name: 'Онлайн зрителей',
			data: data.map(({time, online}) => ([time*1000, online])),
			pointStart: timeLine[0].time * 1000,
			pointInterval: 60000,
			tooltip: {valueDecimals: 0}
		}, {
			type: 'column',
			name: 'Входы',
			data: data.map(({time, connect}) => ([time*1000, connect])),
			pointStart: timeLine[0].time * 1000,
			pointInterval: 60000,
			tooltip: {valueDecimals: 0}
		}, {
			type: 'column',
			name: 'Выходы',
			data: data.map(({time, disconnect}) => ([time*1000, disconnect])),
			pointStart: timeLine[0].time * 1000,
			pointInterval: 60000,
			tooltip: {valueDecimals: 0}
		}]
	};

	return (
		<article>
			<ReactHighstock config={chartConfig}/>
			<Grid fluid>
				<Row className="col-sm-5th">
					<Col sm={1}>
						<Panel className="statistic-counter-value">
							<Panel.Heading>Всего заходов на платформу (не уникальных)</Panel.Heading>
							<Panel.Body>{usersConnect || 0}</Panel.Body>
						</Panel>
					</Col>
					<Col sm={1}>
						<Panel className="statistic-counter-value">
							<Panel.Heading>Сейчас пользователей на платформе</Panel.Heading>
							<Panel.Body>{usersOnline || 0}</Panel.Body>
						</Panel>
					</Col>
					<Col sm={1}>
						<Panel className="statistic-counter-value">
							<Panel.Heading>Всего уникальных пользователей на платформе</Panel.Heading>
							<Panel.Body>{usersUnique || 0}</Panel.Body>
						</Panel>
					</Col>
					<Col sm={1}>
						<Panel className="statistic-counter-value">
							<Panel.Heading>Максимально уникальных пользователей на платформе</Panel.Heading>
							<Panel.Body>{usersOnlineMax || 0}</Panel.Body>
						</Panel>
					</Col>
					<Col sm={1}>
						<Panel className="statistic-counter-value">
							<Panel.Heading>Среднее время нахождения на платформе</Panel.Heading>
							<Panel.Body>{getHumanDuration(avgViewTime, true) || 0}</Panel.Body>
						</Panel>
					</Col>
                    <Col sm={1}>
						<Panel className="statistic-counter-value">
							<Panel.Heading>Приняли участие в голосованиях</Panel.Heading>
							<Panel.Body>{polsMembersUnique || 0}</Panel.Body>
						</Panel>
					</Col>
                    <Col sm={1}>
						<Panel className="statistic-counter-value">
							<Panel.Heading>Приняли участие в квизах</Panel.Heading>
							<Panel.Body>{quizzesMembersUnique || 0}</Panel.Body>
						</Panel>
					</Col>
					{event.moduleComment?.enabled && <Col sm={1}>
						<Panel className="statistic-counter-value">
							<Panel.Heading>Комментариев</Panel.Heading>
							<Panel.Body>{commentsCount || 0}</Panel.Body>
						</Panel>
					</Col>}
					{event.moduleQuestion?.enabled && <Col sm={1}>
						<Panel className="statistic-counter-value">
							<Panel.Heading>Вопросов</Panel.Heading>
							<Panel.Body>{questionsCount || 0}</Panel.Body>
						</Panel>
					</Col>}
                    <Col sm={1}>
						<Panel className="statistic-counter-value">
							<Panel.Heading>Посмотрело прямой эфир</Panel.Heading>
							<Panel.Body>{usersWatchedLive || 0}</Panel.Body>
						</Panel>
					</Col>
                    <Col sm={1}>
                        <Panel className="statistic-counter-value">
                            <Panel.Heading>Конверсия из зарегистрированных в зрителей</Panel.Heading>
                            <Panel.Body>{registrationConversion || 0}%</Panel.Body>
                        </Panel>
                    </Col>
				</Row>
			</Grid>
		</article>
	);
};

const StatisticViewTime = ({event, viewTime, timeStart, timeStop}) => {
    const [clientWatchDuration, setClientWatchDuration] = useState({});

	if(!viewTime.length) return null;

	const names = {
		'0-5': {
            title: 'до 5 минут',
            maxDuration: 5*60,
        },
		'5-15': {
            title: '5 - 15 минут',
            minDuration: 5*60,
            maxDuration: 15*60,
        },
		'15-30': {
            title: '15 - 30 минут',
            minDuration: 15*60,
            maxDuration: 30*60,
        },
		'30-60': {
            title: '30 - 60 минут',
            minDuration: 30*60,
            maxDuration: 60*60,
        },
		'60-120': {
            title: '1 - 2 часа',
            minDuration: 60*60,
            maxDuration: 120*60,
        },
		'120-180': {
            title: '2 - 3 часа',
            minDuration: 120*60,
            maxDuration: 180*60,
        },
		'180-240': {
            title: '3 - 4 часа',
            minDuration: 180*60,
            maxDuration: 240*60,
        },
		'240-300': {
            title: '4 - 5 часов',
            minDuration: 240*60,
            maxDuration: 300*60,
        },
		'300-360': {
            title: '5 - 6 часов',
            minDuration: 300*60,
            maxDuration: 360*60,
        },
		'360-420': {
            title: '6 - 7 часов',
            minDuration: 360*60,
            maxDuration: 420*60,
        },
		'420+': {
            title: 'более 7 часов',
            minDuration: 420*60,
        },
	};

	const chartConfig = {
        accessibility: {
            enabled: false,
        },
		credits: {enabled: false},
		chart: {type: 'column', spacing: [10, 0, 0, 0]},
		title: {text: ''},
		xAxis: {
			type: 'category',
			title: {text: 'минут'}
		},
		yAxis: {
			title: {enabled: false}
		},
		legend: {
			enabled: false
		},
		series: [{
			name: 'Просмотров',
			colorByPoint: true,
			data: viewTime.map(i => [names[i.name].title, i.count]),
            events: {
                click: async (e) => setClientWatchDuration(names[Object.keys(names)[e.point.index]])
            }
		}]
	};

	return (
        <div>
            <WatchDurationClientListModal
                event={event}
                timeStart={timeStart}
                timeStop={timeStop}
                onHide={() => setClientWatchDuration({})}
                {...clientWatchDuration}
            />

            <ReactHighcharts config={chartConfig}/>
        </div>
    );
};

const StatisticStreams = (props) => {
	const {event, streams} = props;
	const {allowPrivateClientDataAccess} = event.client;
    const isEnabledComments = event.moduleComment?.enabled;
    const isEnabledQuestions = event.moduleQuestion?.enabled;

	if(!streams.length) return null;

	return (
		<article>
			{streams.map(stream =>
				<article key={stream.id}>
					<Table>
						<thead>
						<tr>
							<th>{stream.name}{/*Эпизод*/}</th>
							<th style={{width: 220}}>Время</th>
							<th style={{width: 60}}>Просмотров</th>
							<th style={{width: 60}}>Зрителей</th>
							<th style={{width: 60}}>Like</th>
							<th style={{width: 60}}>Избранное</th>
							{isEnabledComments && <th style={{width: 60}}>Комментарии</th>}
							{isEnabledQuestions && <th style={{width: 60}}>Вопросы</th>}
						</tr>
						</thead>
						<tbody>
						{stream.episode.map(({id, key: episodeKey, name, timeStart, timeStop, like, favorite, clientsCount, connectionCount, commentsCount, questionsCount}) =>
							<tr key={id}>
								<td>{name}</td>
								<td>{moment.unix(timeStart).format('D MMMM YYYY, HH:mm')} - {moment.unix(timeStop).format('HH:mm')}</td>
								<td>{connectionCount}</td>
								<td>
									{allowPrivateClientDataAccess ?
										<Link to={`/event/${event.eventPassword}/statistic/episode/${episodeKey}/clients`}>
											{clientsCount || 0}
										</Link>
										: clientsCount || 0
									}
								</td>
								<td>{like || 0}</td>
								<td>{favorite || 0}</td>
								{isEnabledComments && <td>{commentsCount}</td>}
								{isEnabledQuestions && <td>{questionsCount}</td>}
							</tr>
						)}
						</tbody>
					</Table>
				</article>
			)}
		</article>
	)
};

const StatisticBrowsers = (props) => {
	const {browsers} = props;

	if(!browsers.length) return null;

	return <StatisticPieTable titles={['Браузер', 'Зрители']} data={browsers} title="Браузеры" />;
};

const StatisticDevices = (props) => {
	const {devices} = props;

	if(!devices.length) return null;

	return <StatisticPieTable titles={['Система', 'Зрители']} data={devices} title="Операционные системы" />;
};

const StatisticCountries = (props) => {
	const {countries} = props;

	if(!countries.length) return null;

	return <StatisticPieTable titles={['Страна', 'Зрители']} data={countries} title="Страны" />;
};

const StatisticCities = (props) => {
	const {cities} = props;

	if(!cities.length) return null;

	return <StatisticPieTable titles={['Город', 'Зрители']} data={cities} title="Города" />;
};

const StatisticClients = (props) => {
	const {event, clients} = props;

	if(!clients.length) return null;

	return <ClientTable clients={clients} event={event}
		timeStart={props.timeStart || event.timeStart}
		timeStop={props.timeStop || event.timeStop}
	/>;
};

class StatisticHosts extends React.Component {
	state = {
		showPages: []
	};

	constructor(props) {
		super(props);

		this.showPages = this.showPages.bind(this);
		this.hidePages = this.hidePages.bind(this);
	}

	showPages(pages) {
		this.setState({showPages: pages});
	}
	hidePages() {
		this.setState({showPages: []});
	}

	renderTable(hosts) {
		return (
			<Table>
				<thead>
				<tr>
					<th>Сайт</th>
					<th style={{width: '20%', textAlign: 'right'}}>Зрители</th>
				</tr>
				</thead>
				<tbody>
				{hosts.map(host => <tr key={host.name}>
					<td style={{wordBreak: 'break-all'}}>
						{host.page ?
							<a href="#" onClick={e => { e.preventDefault(); this.showPages(host.page); }}>{host.name || UnknownLabel}</a>
							:
							<a href={host.name} target="_blank">{host.name || UnknownLabel}</a>
						}
					</td>
					<td style={{textAlign: 'right'}}>{host.count}</td>
				</tr>)}
				</tbody>
			</Table>
		);
	}

	render() {
		const {hosts} = this.props;
		const {showPages} = this.state;

		if(!hosts.length) return null;

		return (
			<article>
				{this.renderTable(hosts)}

				<Modal show={showPages.length > 0} onHide={this.hidePages} bsSize="large">
					<Modal.Header closeButton>
						<Modal.Title>Страницы</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{this.renderTable(showPages)}
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={this.hidePages}>Закрыть</Button>
					</Modal.Footer>
				</Modal>
			</article>
		);

	}
}

const StatisticPolls = ({event, polls, clients, allowPrivateClientDataAccess}) => {
    const [selectedPollAnswer, setSelectedPollAnswer] = useState(null);

    if (!polls.length) return null;

    const ShowClientsLink = ({poll, answer, children}) => {
        if (!allowPrivateClientDataAccess || !poll.authorizationRequired) {
            return children;
        }

        return <a onClick={() => setSelectedPollAnswer(answer)}>{children}</a>;
    };

    const PollAnswerResult = ({poll, answer}) => {
        return answer.count;
    };

    let prevPoll = null;

    return (
        <article>
            {polls.map(poll => {
                const result = (
                    <div key={poll.id}>
                        {(null === prevPoll || prevPoll.streamId !== poll.streamId) &&
                            <h4 style={{fontWeight: "bold"}}>{poll.streamDescription}</h4>
                        }
                        <Table>
                            <thead>
                            <tr>
                                <th>
                                    <span>{poll.textRu}</span>
                                    <span style={{marginLeft: 10, color: 'red', fontWeight: 'normal'}}>{locale('poll.type.' + poll.type)}</span>
                                </th>
                                <th style={{width: 80}}>Зрители</th>
                            </tr>
                            </thead>
                            <tbody>
                            {poll.answer.map(answer =>
                                <tr key={answer.id}>
                                    <td>
                                        <ShowClientsLink poll={poll} answer={answer}>{answer.textRu}</ShowClientsLink>
                                    </td>
                                    <td>
                                        <PollAnswerResult poll={poll} answer={answer} />
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </Table>
                    </div>
                );
                prevPoll = poll;

                return result;
            })}

            <div style={{textAlign: 'right'}}>
                <Button href={`/api/cp/event/${event.eventPassword}/statistic/polls.xlsx`}>Скачать</Button>
            </div>

            <Modal show={!!selectedPollAnswer} onHide={() => setSelectedPollAnswer(null)} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>Зрители</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedPollAnswer && selectedPollAnswer.client && selectedPollAnswer.client.length > 0 &&
                        <ClientTable
                            clients={selectedPollAnswer.client}
                            event={event}
                            full
                            hideButtons
                        />
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => setSelectedPollAnswer(null)}>Закрыть</Button>
                </Modal.Footer>
            </Modal>
        </article>
    );
};

const StatisticActivityTop = ({activityTop}) => {
	const [data, setData] = useState(activityTop || []);

	if (!data.length) {
		return null;
	}

	return (
		<article>
			<Event event={'activityTop'} handler={(result) => setData(result || [])} />
			{data.map((activityTopItem, index) =>
			<div key={index}>
				{(activityTopItem.stream || activityTopItem.date) &&
					<div>
						{activityTopItem.stream &&
							<span>
								<b style={{marginRight: 5}}>Зал</b>
								{activityTopItem.stream.description_ru}
							</span>
						}
						{activityTopItem.date &&
							<span>
								<b style={{marginRight: 5}}>Дата</b>
								{activityTopItem.date}
							</span>
						}
					</div>
				}
				<Table>
					<thead>
					<tr>
						<th style={{width: 1}}>#</th>
						<th>Пользователь</th>
						<th style={{width: 80}}>Баллы</th>
					</tr>
					</thead>
					<tbody>
						{activityTopItem.top.map((value, index) =>
						<tr key={index}>
							<td>
								{index + 1}
							</td>
							<td>
								{getClientNickname(value.client)}
							</td>
							<td>{value.points}</td>
						</tr>
						)}
					</tbody>
				</Table>
			</div>
			)}
		</article>
	);
}

const StatisticNotifications = (props) => {
	const {notifications} = props;

	if(!notifications.length) return null;

	return (
		<Table>
			<thead>
			<tr>
				<th>Сообщение</th>
				<th style={{width: 80}}>Переходы</th>
			</tr>
			</thead>
			<tbody>
			{notifications.map(notification =>
				<tr key={notification.id}>
					<td>{notification.name}</td>
					<td>{notification.click}</td>
				</tr>
			)}
			</tbody>
		</Table>
	);
};

const StatisticBanners = (props) => {
	const {banners} = props;

	if(!banners.length) return null;

	return (
			<Table>
				<thead>
				<tr>
					<th>Баннер</th>
					<th style={{width: 80}}>Переходы</th>
				</tr>
				</thead>
				<tbody>
				{banners.map(banner =>
					<tr key={banner.id}>
						<td><img src={banner.url} width="600" alt="" /></td>
						<td>{banner.click}</td>
					</tr>
				)}
				</tbody>
			</Table>
	);
};

class StatisticPayments extends React.Component {
	state = {
		showModal: false
	};

	constructor(props, context) {
		super(props, context);

		this.showModal = this.showModal.bind(this);
		this.hideModal = this.hideModal.bind(this);
	}

	showModal() {
		this.setState({showModal: true});
	}
	hideModal() {
		this.setState({showModal: false});
	}

	render() {
		const {payments} = this.props;
		const overviewTableSize = 10;

		if (!payments.length) return null;

		const PaymentTable = ({payments}) => (
			<Table>
				<thead>
				<tr>
					<th>eMail</th>
					<th style={{width: 160}}>Стоимость</th>
					<th style={{width: 160}}>Дата</th>
				</tr>
				</thead>
				<tbody>
				{payments.map(({id, email, price, createdAt}) =>
					<tr key={`payment_${id}`}>
						<td>{email}</td>
						<td>{price.toFixed(2)} руб</td>
						<td>{moment.unix(createdAt).format('YYYY-MM-DD HH:mm:ss')}</td>
					</tr>
				)}
				</tbody>
			</Table>
		);

		const PaymentModal = ({isShow, onHide, payments}) => (
			<Modal show={isShow} onHide={onHide} bsSize="large">
				<Modal.Header closeButton>
					<Modal.Title>Платежи</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{overflow: 'auto'}}>
					<PaymentTable payments={payments} />
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={onHide}>Закрыть</Button>
				</Modal.Footer>
			</Modal>
		);

		return (
			<div>
				<PaymentTable payments={payments.slice(0, overviewTableSize)} />

				<div style={{float: 'right'}}>
					{/*<Button href={`/api/cp/event/${event.eventPassword}/client.xlsx`}>Скачать</Button>{' '}*/}
					{payments.length > 10 && <Button onClick={this.showModal}>Показать все</Button>}
				</div>
				<div>
					<strong>Итого:</strong> {payments.reduce((sum, payment) => sum + payment.price, 0).toFixed(2)} руб
					({payments.length} покупок)
				</div>

				<PaymentModal isShow={this.state.showModal} onHide={this.hideModal} payments={payments} />
			</div>
		);
	}
}


class EventStatistic extends React.Component {
	state = {
		isLoading: true,
        participationType: '',
		timeLine: [],
		usersOnline: 0,
		usersOnlineMax: 0,
		usersConnect: 0,
		usersUnique: 0,
		viewTime: [],
		streams: [],
		browsers: [],
		devices: [],
		countries: [],
		cities: [],
		clients: [],
		hosts: [],
		polls: [],
		notifications: [],
		banners: [],
		payments: [],
        registrationConversion: 0,
		activityTop: [],
	};

	constructor(props, context) {
		super(props, context);

		this.handleChangeDate = this.handleChangeDate.bind(this);
        this.handleChangeParticipationType = this.handleChangeParticipationType.bind(this);
		this.handleResetDate = this.handleResetDate.bind(this);
	}

	fetchTimeLine(params) {
		const {event} = this.props;

        return eventStatisticTimeLineGet(event.eventPassword, params)
			.then(timeLine => {
				const usersOnlineMax = timeLine.reduce((maxOnline, i) => Math.max(maxOnline, i.online), 0);
				this.setState({
					timeLine,
					usersOnlineMax,
				});
			});
	}
	fetchOnline(params) {
		const {event} = this.props;

        return eventStatisticOnlineGet(event.eventPassword, params)
			.then(response => {
				const {usersOnline, usersConnect, usersUnique, avgViewTime, usersWatchedLive} = response;
				this.setState({
					usersOnline,
					usersConnect,
					usersUnique,
					avgViewTime,
                    usersWatchedLive,
				});
			});
	}
	fetchViewTime(params) {
		const {event} = this.props;

        return eventStatisticViewTimeGet(event.eventPassword, params)
			.then(viewTime => this.setState({viewTime}));
	}
	fetchStreams(params) {
		const {event} = this.props;

        return eventStatisticStreamsGet(event.eventPassword, params)
			.then(streams => this.setState({streams}));
	}
	fetchBrowsers(params) {
		const {event} = this.props;

        return eventStatisticBrowsersGet(event.eventPassword, params)
			.then(browsers => this.setState({browsers}));
	}
	fetchDevices(params) {
		const {event} = this.props;

        return eventStatisticDevicesGet(event.eventPassword, params)
			.then(devices => this.setState({devices}));
	}
	fetchCountries(params) {
		const {event} = this.props;

        return eventStatisticCountriesGet(event.eventPassword, params)
			.then(countries => this.setState({countries}));
	}
	fetchCities(params) {
		const {event} = this.props;

        return eventStatisticCitiesGet(event.eventPassword, params)
			.then(cities => this.setState({cities}));
	}
	fetchClients(params) {
		const {event} = this.props;

        return eventStatisticClientsGet(event.eventPassword, params)
			.then(clients => this.setState({clients}));
	}
	fetchHosts(params) {
		const {event} = this.props;

        return eventStatisticHostsGet(event.eventPassword, params)
			.then(hosts => this.setState({hosts}));
	}
	fetchPolls(params) {
		const {event} = this.props;

        return eventStatisticPollsGet(event.eventPassword, params)
			.then(polls => this.setState({polls}));
	}
    fetchPollsMember(params) {
		const {event} = this.props;

        return eventStatisticPollsMember(event.eventPassword, params)
			.then(({polsMembersUnique, quizzesMembersUnique}) => this.setState({polsMembersUnique, quizzesMembersUnique}));
	}
	fetchActivityTop(params) {
		const {event} = this.props;

        return eventStatisticActivityTopGet(event.eventPassword, params)
			.then(activityTop => this.setState({activityTop}));
	}
	fetchNotifications(params) {
		const {event} = this.props;

        return eventStatisticNotificationsGet(event.eventPassword, params)
			.then(notifications => this.setState({notifications}));
	}
	fetchBanners(params) {
		const {event} = this.props;

        return eventStatisticBannersGet(event.eventPassword, params)
			.then(banners => this.setState({banners}));
	}
	fetchMessagesCount(params) {
		const {event} = this.props;

        return eventStatisticMessagesGet(event.eventPassword, params)
            .then(response => {
                const {commentsCount, questionsCount} = response;
                this.setState({
                    commentsCount,
                    questionsCount,
                });
            });
	}
	fetchPayments(params) {
		const {event} = this.props;

        return eventStatisticPaymentsGet(event.eventPassword, params)
			.then(payments => this.setState({payments}));
	}
    fetchRegistrationConversion(params) {
        const {event} = this.props;

        return eventStatisticRegistrationConversion(event.eventPassword, params)
            .then(({percentageConversion: registrationConversion}) => this.setState({registrationConversion}));
    }

	async fetch(timeStart, timeStop, participationType) {
		this.setState({isLoading: true});

		const params = {timeStart, timeStop};
		if (participationType) {
			params.participationType = participationType;
		}

		const loadingTasks = [
			this.fetchTimeLine,
			this.fetchOnline,
			this.fetchViewTime,
			this.fetchStreams,
			this.fetchBrowsers,
			this.fetchDevices,
			this.fetchCountries,
			this.fetchCities,
			this.fetchClients,
			this.fetchHosts,
			this.fetchPolls,
            this.fetchPollsMember,
			this.fetchActivityTop,
			this.fetchNotifications,
			this.fetchBanners,
			this.fetchPayments,
			this.fetchMessagesCount,
            this.fetchRegistrationConversion,
		];

        try {
            await Promise.all(loadingTasks.map(task => task.call(this, params)));
            this.setState({isLoading: false, ...params});
        } catch (e) {
            console.error(e);
            this.setState({isLoading: false});
        }
	}

    onChangeParams(params) {
        const {event, history} = this.props;
        const query = Object.keys(params).map((key) => `${key}=${params[key]}`).join('&');
        history.push(`/event/${event.eventPassword}/statistic?${query}`);
    }
	handleChangeDate(e, picker) {
        const {participationType} = this.state;

        if (!picker) {
            let time = e.target.value.split(' - ');
            picker = {
                startDate: moment(time[0]),
                endDate: moment(time[1]),
            }
        }

        const timeStart = picker.startDate.unix();
        const timeStop = picker.endDate.unix();

        this.onChangeParams({timeStart, timeStop, participationType});
	}
    handleChangeParticipationType(participationType) {
        const {timeStart, timeStop} = this.state;

        this.onChangeParams({timeStart, timeStop, participationType});
    }
	handleResetDate() {
        this.onChangeParams({});
	}

	componentDidMount() {
		this.updateData(this.props);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.location.search !== this.props.location.search || prevProps.event !== this.props.event) {
			this.updateData(this.props);
		}
	}

	updateData(props) {
		const {event, location} = props;
        const query = new URLSearchParams(location.search);
        const timeStart = query.get('timeStart') || event.timeStart;
        const timeStop = query.get('timeStop') || event.timeStop;
        const participationType = query.get('participationType');
		this.fetch(timeStart, timeStop, participationType);
	}

	render() {
		const {event} = this.props;
		const {allowPrivateClientDataAccess} = event.client;
		const state = this.state;
		const {isLoading} = this.state;
		const {timeLine} = this.state;
		const {
			viewTime,
			streams,
			browsers,
			devices,
			countries,
			cities,
			clients,
			hosts,
			polls,
			activityTop,
			payments
		} = this.state;
		const {notifications, banners} = this.state;

		const timeStart = this.state.timeStart || event.timeStart;
		const timeStop = this.state.timeStop || event.timeStop;

		if(isLoading) return <Loading modal>Загрузка данных статистики...</Loading>;

		function MenuItem (key, title, Component, isEnabled) {
			const scrollToSection = e => {
				e.preventDefault();
				const position = $(`#${key}`).position();
				if(position) {
					const scrollTop = position.top - $('.wrapper .navbar').outerHeight(true);
					$('html').animate({scrollTop});
				}
			};

			this.isEnabled = isEnabled;
			this.menu = () => (
				<p key={key}>
					<a onClick={scrollToSection} href={`#${key}`}>
						{title}
					</a>
				</p>
			);
			this.component = () => (
				<section key={key}>
					<h4 id={key}>{title}</h4>
					<Component {...state} event={event} allowPrivateClientDataAccess={allowPrivateClientDataAccess} />
				</section>
			);
		}

		const sections = [
			new MenuItem('timeLine', 'Статистика пользователей', StatisticTimeLine, () => timeLine.length > 0),
		 	new MenuItem('viewTime', 'Продолжительность просмотров', StatisticViewTime, () => viewTime.length > 0),
			new MenuItem('streams', 'Просмотр эпизодов', StatisticStreams, () => streams.length > 0),
			new MenuItem('browsers', 'Браузеры', StatisticBrowsers, () => browsers.length > 0),
			new MenuItem('devices', 'Операционные системы', StatisticDevices, () => devices.length > 0),
			new MenuItem('countries', 'Страны', StatisticCountries, () => countries.length > 0),
			new MenuItem('cities', 'Города', StatisticCities, () => cities.length > 0),
			new MenuItem('clients', 'Зрители', StatisticClients, () => clients.length > 0 && allowPrivateClientDataAccess),
			new MenuItem('hosts', 'Сайты', StatisticHosts, () => hosts.length > 0),
			new MenuItem('polls', 'Опросы', StatisticPolls, () => polls.length > 0),
			new MenuItem('activityTop', 'Активный участник', StatisticActivityTop, () => activityTop.length > 0),
			new MenuItem('notifications', 'Сообщения', StatisticNotifications, () => notifications.length > 0),
			new MenuItem('banners', 'Баннеры', StatisticBanners, () => banners.length > 0),
			new MenuItem('payments', 'Платежи', StatisticPayments, () => event.price && payments.length > 0),
		];

		const enabledSections = sections.filter(section => section.isEnabled());

		return (
			<section className="statistic">
				<Breadcrumb>
					<LinkContainer to={`/event/${event.eventKey}`}><Breadcrumb.Item>Трансляция</Breadcrumb.Item></LinkContainer>
					<Breadcrumb.Item active>Статистика</Breadcrumb.Item>
				</Breadcrumb>

				<nav className="statistic-sidebar">
					{enabledSections.map(section => section.menu())}
				</nav>

				<section className="statistic-content">
					<h3 style={{whiteSpace: 'pre'}}>{event.name_ru}</h3>

					<section>
						<Form inline>
							<FormGroup>
								<DatetimeRangePicker startDate={moment.unix(timeStart)} endDate={moment.unix(timeStop)} timePicker timePicker24Hour timePickerSeconds onApply={this.handleChangeDate} locale={DatetimeRangePickerLocale} applyClass="btn-primary" cancelClass="btn-link">
									<FormControl size="45" type="text" name="timeStart" value={`${moment.unix(timeStart).format('YYYY-MM-DD HH:mm:ss')} - ${moment.unix(timeStop).format('YYYY-MM-DD HH:mm:ss')}`} onChange={this.handleChangeDate} />
								</DatetimeRangePicker>
							</FormGroup>
                            {' '}
                            {event.participationType === 'hybrid' && <FormControl
                                componentClass="select"
                                placeholder="Формат участия"
                                value={'' + this.state.participationType}
                                onChange={(e) => this.handleChangeParticipationType(e.target.value)}
                            >
                                <option value="">Все</option>
                                <option value="online">Онлайн</option>
                                <option value="offline">Офлайн</option>
                            </FormControl>}
							{' '}
							<FormGroup>
								{(timeStart !== event.timeStart || timeStop !== event.timeStop) &&
								<Button type="reset" onClick={this.handleResetDate}>Сбросить</Button>}
							</FormGroup>
							{' '}
							<FormGroup>
								<Button href={`/api/cp/event/${event.eventPassword}/statistic.pdf?timeStart=${timeStart}&timeStop=${timeStop}`}>Скачать PDF</Button>
							</FormGroup>
						</Form>
					</section>

					{enabledSections.map(section => section.component())}
				</section>

			</section>
		);
	}

}

const mapStateToProps = (store) => {
	return {
		event: store.currentEvent
	}
};

export default connect(mapStateToProps)(EventStatistic);

